var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GridColumn",style:({
    'text-align': _vm.align,
    'vertical-align': _vm.valign,
    'width': (_vm.width + "%")
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }